module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av207-ad35e97a72c72a76c67ea733109e8b4b.jpg";